"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeReloadApp = exports.getAppVersionUpdateInProgress = exports.removeAppVersionUpdateInProgress = exports.unregisterServiceWorker = void 0;
const __1 = require("..");
const FORCE_UPDATE_APP_VERSION = 'appVersionUpdate';
const clearCache = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        window.localStorage.clear();
        const caches = window.caches;
        if (caches) {
            // Service worker cache should be cleared with caches.delete()
            yield caches.keys().then((names) => __awaiter(void 0, void 0, void 0, function* () {
                yield Promise.all(names.map(name => caches.delete(name)));
            }));
        }
    }
    catch (err) {
        // do nothing
    }
});
const unregisterServiceWorker = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if ('serviceWorker' in navigator) {
            yield navigator.serviceWorker.ready.then((registration) => __awaiter(void 0, void 0, void 0, function* () {
                yield registration.unregister();
            }));
        }
    }
    catch (err) {
        // do nothing
    }
});
exports.unregisterServiceWorker = unregisterServiceWorker;
const setAppVersionUpdateInProgress = (currentAppVersion) => {
    var _a;
    const existingParams = (_a = (0, __1.parseQueryParams)(window.location.search)) !== null && _a !== void 0 ? _a : {};
    return window.history.replaceState(null, '', `${window.location.pathname}${(0, __1.buildSearchQueryParams)(Object.assign(Object.assign({}, existingParams), { [FORCE_UPDATE_APP_VERSION]: currentAppVersion }))}`);
};
const removeAppVersionUpdateInProgress = () => {
    var _a;
    const _b = (_a = (0, __1.parseQueryParams)(window.location.search)) !== null && _a !== void 0 ? _a : {}, _c = FORCE_UPDATE_APP_VERSION, reloadInProgress = _b[_c], existingParams = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
    return window.history.replaceState(null, '', `${window.location.pathname}${(0, __1.buildSearchQueryParams)(Object.assign({}, existingParams))}`);
};
exports.removeAppVersionUpdateInProgress = removeAppVersionUpdateInProgress;
const getAppVersionUpdateInProgress = () => {
    var _a;
    const { [FORCE_UPDATE_APP_VERSION]: updateInProgress } = (_a = (0, __1.parseQueryParams)(window.location.search)) !== null && _a !== void 0 ? _a : {};
    return updateInProgress;
};
exports.getAppVersionUpdateInProgress = getAppVersionUpdateInProgress;
const maybeReloadApp = (currentAppVersion) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        setAppVersionUpdateInProgress(currentAppVersion);
        yield (0, exports.unregisterServiceWorker)();
        yield clearCache();
        window.location.reload();
    }
    catch (_a) {
        // do nothing for now
    }
});
exports.maybeReloadApp = maybeReloadApp;
